import { useMutation } from '@apollo/client';

import { refetchQueryGetRecurringExportsQuery } from 'features/Accounting/pages/ExportsHome/hooks/useGetRecurringExports';

import { CreateAccountingRecurringExportDocument } from './createAccountingRecurringExport.gql';

const useCreateAccountingRecurringExport = (companyProfileId: string) => {
  return useMutation(CreateAccountingRecurringExportDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchQueryGetRecurringExportsQuery({ companyProfileId }),
    ],
  });
};

export default useCreateAccountingRecurringExport;
